/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import SearchIcon from "@mui/icons-material/Search";
import UpArrowIcon from "@mui/icons-material/ArrowUpward";
import DownArrowIcon from "@mui/icons-material/ArrowDownward";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import logo from "../assets/logo.png";
import "./header.css";
import {
  clinical,
  healthcare,
  product,
  research,
  researchcard,
  chestPainCirculatory,
  irregularHeartbeatsPalpitations,
  highBloodPressureCholesterol,
  heartFailureDisorders,
  preventiveGeneticRiskAssessment,
  clinicalConsultations,
  interventionalCardiology,
  medicalAcademicConsultation,
  advancedCardiacCare,
  expertDiagnosticsSpecialist,
  medicalTourism,
  medicalDeviceConsultation,
  medicalLanguageTranslation,
  gallery,
  videos,
  metaAnalysis,
  blog,
} from "../../Navigation/constant";

const useWindowWidth = () => {
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
};

const DropdownNavItem = ({ label, to, items, menuKey, openMenu, setOpenMenu, isMobile, navLinkStyle }) => {
  const isOpen = openMenu === menuKey;
  const trigger = to ? (
    <NavLink
      to={to}
      className="nav-link"
      style={({ isActive }) => ({ ...navLinkStyle, color: isActive ? "#2acb35" : navLinkStyle.color })}
      onClick={() => isMobile && setOpenMenu(isOpen ? null : menuKey)}
    >
      {label}
    </NavLink>
  ) : (
    <a
      href="#"
      className="nav-link"
      style={navLinkStyle}
      onClick={(e) => {
        e.preventDefault();
        if (isMobile) setOpenMenu(isOpen ? null : menuKey);
      }}
    >
      {label}
    </a>
  );

  return (
    <li
      className="nav-item"
      style={{ position: "relative" }}
      onMouseEnter={() => !isMobile && setOpenMenu(menuKey)}
      onMouseLeave={() => !isMobile && setOpenMenu(null)}
    >
      {trigger}
      <ul
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          background: "#fff",
          minWidth: "240px",
          margin: 0,
          padding: "8px 0",
          listStyle: "none",
          boxShadow: "0 10px 24px rgba(0,0,0,0.14)",
          borderRadius: "2px",
          zIndex: 1000,
          display: isOpen ? "block" : "none",
        }}
      >
        {items.map((item) => (
          <li key={item.label}>
            <NavLink
              to={item.path}
              style={{ display: "block", padding: "10px 18px", color: "#333", fontSize: "14px", textDecoration: "none", whiteSpace: "nowrap" }}
              onClick={() => setOpenMenu(null)}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </li>
  );
};

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [searchAlert, setSearchAlert] = useState(false);
  const [targetText, setTargetText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [openMenu, setOpenMenu] = useState(null);
  const width = useWindowWidth();
  const isMobile = width <= 992;
  const isSmall = width <= 768;
  const isTiny = width <= 480;
  const { pathname } = useLocation();
  const wrapperRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    // ensure no horizontal overflow
    document.documentElement.style.overflowX = "hidden";
    document.documentElement.style.maxWidth = "100%";
    document.body.style.overflowX = "hidden";
    document.body.style.maxWidth = "100%";
  }, []);

  useEffect(() => {
    // close transient UI on route change and reset scroll behavior briefly
    setOpenMenu(null);
    setSearchAlert(false);
    try {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    } catch (e) {}
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const t = setTimeout(() => (html.style.scrollBehavior = prev || ""), 300);
    return () => clearTimeout(t);
  }, [pathname]);

  const navLinkStyle = { color: "#333", fontSize: isSmall ? "13px" : "14px", padding: "6px 10px", margin: 0, textDecoration: "none", fontWeight: 500, whiteSpace: "nowrap", display: "inline-block" };

  const dropdownMenus = {
    conditions: [
      { label: "Chest Pain & Circulatory Issues", path: chestPainCirculatory },
      { label: "Irregular Heartbeats & Palpitations", path: irregularHeartbeatsPalpitations },
      { label: "High Blood Pressure & Cholesterol", path: highBloodPressureCholesterol },
      { label: "Heart Failure & Valve Disorders", path: heartFailureDisorders },
      { label: "Preventive & Genetic Risk Assessment", path: preventiveGeneticRiskAssessment },
    ],
    media: [
      { label: "Gallery", path: gallery },
      { label: "Videos", path: videos },
      { label: "Blogs", path: blog },
    ],
    learning: [
      { label: "Publications", path: research },
      { label: "Research", path: researchcard },
      { label: "Easy Clinical Learning", path: clinical },
      { label: "HealthCare", path: healthcare },
      { label: "OTHERs", path: product },
    ],
    services: [
      { label: "Clinical Consultation", path: clinicalConsultations },
      { label: "Interventional Cardiology Services", path: interventionalCardiology },
      { label: "Medical Academic Research Consultation services", path: medicalAcademicConsultation },
      { label: "Meta - Analysis", path: metaAnalysis },
      { label: "Advanced Cardiac Care & Disease Management", path: advancedCardiacCare },
      { label: "Expert Diagnostics & Specialist Opinions", path: expertDiagnosticsSpecialist },
      { label: "Global Cardiac Access & Medical Tourism", path: medicalTourism },
      { label: "Medical Device & Pharmaceutical Product Consultation", path: medicalDeviceConsultation },
      { label: "Medical language translation section", path: medicalLanguageTranslation },
    ],
  };

  const clearHighlights = () => {
    const highlightedElements = document.querySelectorAll(".highlight");
    highlightedElements.forEach((el) => (el.outerHTML = el.innerHTML));
  };

  const scrollToText = (e) => {
    e && e.preventDefault();
    clearHighlights();
    setSearchResults([]);
    setCurrentIndex(-1);
    if (!targetText) return;
    const q = targetText.toLowerCase();
    const elems = document.querySelectorAll("p, h1, h2, h3, h4, h5, h6, button, a, li");
    const results = [];
    elems.forEach((el) => {
      if (el.textContent && el.textContent.toLowerCase().includes(q)) {
        const regex = new RegExp(`(${targetText})`, "gi");
        el.innerHTML = el.innerHTML.replace(regex, '<span class="highlight">$1</span>');
        results.push(el);
      }
    });
    if (results.length) {
      setSearchResults(results);
      setCurrentIndex(0);
      results[0].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const navigateResults = (direction) => {
    if (searchResults.length === 0) return;
    let idx = currentIndex + direction;
    if (idx < 0) idx = searchResults.length - 1;
    if (idx >= searchResults.length) idx = 0;
    setCurrentIndex(idx);
    searchResults[idx].scrollIntoView({ behavior: "smooth", block: "center" });
  };

  useEffect(() => {
    const measure = () => {
      if (wrapperRef.current) setHeaderHeight(wrapperRef.current.getBoundingClientRect().height);
    };
    // measure on rAF, resize and fonts load
    const onResize = () => requestAnimationFrame(measure);
    requestAnimationFrame(measure);
    window.addEventListener("resize", onResize);
    if (document && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(() => {});
    }
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Diagnostic: log elements that have their own scrollbars (possible extra scroll indicator)
  useEffect(() => {
    if (!pathname.includes("about")) return;
    const els = Array.from(document.querySelectorAll("*")).filter((el) => {
      try {
        return el.scrollHeight > el.clientHeight + 1;
      } catch (e) {
        return false;
      }
    });
    if (els.length) {
      console.warn("Scrollable elements on this page (possible extra scrollbar):", els.map((el) => ({ tag: el.tagName, class: el.className, id: el.id, scrollHeight: el.scrollHeight, clientHeight: el.clientHeight })) );
    } else {
      console.warn("No inner scrollable elements detected on About page");
    }
  }, [pathname]);

  return (
    <>
      <div ref={wrapperRef} style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100, background: "transparent" }}>
        <header style={{ background: "#181515", width: "100%" }}>
          <div className="container cmd" style={{ boxSizing: "border-box", padding: isTiny ? "8px 12px" : "8px 16px" }}>
            <ul className="iconList" style={{ display: "flex", gap: "8px", alignItems: "center", margin: 0, padding: 0 }}>
              <li style={{ display: "flex", alignItems: "center", gap: "6px", color: "#8e8a8a" }}>
                <PhoneIcon style={{ fontSize: isTiny ? "16px" : "20px" }} />
                Phone:
                <Link to={"tel:+86 198 1197 6744"} style={{ color: "#8e8a8a", marginLeft: 6 }}>(+86 )198 1197-6744</Link>
              </li>
              <li style={{ display: "flex", alignItems: "center", gap: "6px", color: "#8e8a8a" }}>
                <MailIcon style={{ fontSize: isTiny ? "16px" : "20px" }} />
                Email:
                <Link to={"mailto:consult@drsiamalmobarakcardio.com"} style={{ color: "#8e8a8a", marginLeft: 6 }}>consult@drsiamalmobarakcardio.com</Link>
              </li>
              <li style={{ marginLeft: "auto" }}>
                <select id="languageSelect" style={{ minWidth: 120 }}>
                  <option value="" disabled selected>Select a language</option>
                </select>
              </li>
            </ul>
          </div>
        </header>

        <nav className={`navbar navbar-expand-lg navbar-light ${scrolled ? "scrolled fadeInUp" : ""}`} style={{ position: "relative", zIndex: 1110, background: "#fff" }}>
          <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", boxSizing: "border-box" }}>
            {!isMobile && <div style={{ width: isSmall ? "24px" : isTiny ? "16px" : width < 1400 ? "32px" : "56px" }}></div>}
            <NavLink className="navbar-brand" to="/">
              <img src={logo} alt="" style={{ maxHeight: isSmall ? 46 : 55, objectFit: "contain", padding: "1px 0" }} />
            </NavLink>
            

            {isMobile && (
              <SwipeableTemporaryDrawer
                menuItems={[
                  { name: "Home", path: "/" },
                  { name: "About", path: "/about" },
                  { name: "Conditions & Symptoms", children: dropdownMenus.conditions },
                  { name: "Media", children: dropdownMenus.media },
                  { name: "Learning Zone", children: dropdownMenus.learning },
                  { name: "Services", children: dropdownMenus.services },
                  { name: "CONSULTATIONS", path: "/consultations" },
                  { name: "Appointment", path: "/contact" },
                ]}
              />
            )}

            <div id="navbarSupportedContent" style={{ display: isMobile ? "none" : "flex", alignItems: "center", gap: "16px" }}>
              <ul style={{ display: "flex", alignItems: "center", listStyle: "none", margin: 0, padding: 0, gap: "8px" }}>
                <li className="nav-item"><NavLink to="/" className="nav-link" style={navLinkStyle}>Home</NavLink></li>
                <li className="nav-item"><NavLink to="/about" className="nav-link" style={navLinkStyle}>About</NavLink></li>

                <DropdownNavItem label="Conditions & Symptoms" menuKey="conditions" items={dropdownMenus.conditions} openMenu={openMenu} setOpenMenu={setOpenMenu} isMobile={isMobile} navLinkStyle={navLinkStyle} />

                <DropdownNavItem label="Media" to={gallery} menuKey="media" items={dropdownMenus.media} openMenu={openMenu} setOpenMenu={setOpenMenu} isMobile={isMobile} navLinkStyle={navLinkStyle} />

                <DropdownNavItem label="Learning Zone" to={research} menuKey="learning" items={dropdownMenus.learning} openMenu={openMenu} setOpenMenu={setOpenMenu} isMobile={isMobile} navLinkStyle={navLinkStyle} />

                <DropdownNavItem label="Services" menuKey="services" items={dropdownMenus.services} openMenu={openMenu} setOpenMenu={setOpenMenu} isMobile={isMobile} navLinkStyle={navLinkStyle} />

                <li className="nav-item"><NavLink to="/consultations" className="nav-link" style={navLinkStyle}>CONSULTATIONS</NavLink></li>

                <li className="nav-item" style={{ borderLeft: "1px solid #EFEDED", padding: "0 8px", position: "relative" }}>
                  <a href="#" className="nav-link" style={navLinkStyle} onClick={(e) => { e.preventDefault(); setSearchAlert(!searchAlert); }}><SearchIcon /></a>
                  {searchAlert && (
                    <div style={{ position: "absolute", right: 0, top: "44px", background: "#fff", padding: 8, boxShadow: "0 6px 16px rgba(0,0,0,0.14)", borderRadius: 8, zIndex: 1000, width: 280 }}>
                      <form onSubmit={scrollToText}>
                        <div style={{ display: "flex", alignItems: "center", height: 36 }}>
                          <input type="search" placeholder="Search here" onChange={(e) => setTargetText(e.target.value)} style={{ flex: 1, minWidth: 0 }} />
                          <div onClick={scrollToText} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}><SearchIcon /></div>
                        </div>
                      </form>
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                        <div>{searchResults.length > 0 && (<div>{currentIndex + 1} / {searchResults.length}</div>)}</div>
                        <div><button type="button" onClick={() => navigateResults(-1)}><UpArrowIcon/></button><button type="button" onClick={() => navigateResults(1)}><DownArrowIcon/></button></div>
                      </div>
                    </div>
                  )}
                </li>
              </ul>

              <NavLink to="/contact"><form style={{ margin: 0 }}><button type="submit" style={{ background: "#2acb35", color: "#fff", border: "none", padding: isTiny ? "10px 20px" : "10px 28px", borderRadius: 999, cursor: "pointer", fontSize: isTiny ? 12 : 14, fontWeight: 600 }}>APPOINTMENT</button></form></NavLink>
            </div>
            {!isMobile && <div style={{ width: isSmall ? "24px" : isTiny ? "16px" : width < 1400 ? "32px" : "56px" }}></div>}
          </div>
        </nav>
      </div>

      {/* spacer to avoid content jumping under fixed header */}
      <div style={{ height: headerHeight }} aria-hidden="true" />
    </>
  );
};

export default Header;

export const SwipeableTemporaryDrawer = ({ menuItems = null }) => {
  const [state, setState] = React.useState({ left: false });
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    setState({ ...state, [anchor]: open });
  };

  const buildList = (anchor) => (
    <Box sx={{ width: 300 }} role="presentation" onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
      <List>
        {(menuItems || []).map((item) => (
          <React.Fragment key={item.name}>
            <ListItem disablePadding>
              {item.path ? (
                <NavLink to={item.path} style={{ width: "100%", textDecoration: "none", color: "inherit" }}>
                  <ListItemButton>
                    <ListItemText primary={item.name} />
                  </ListItemButton>
                </NavLink>
              ) : (
                <ListItemButton>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              )}
            </ListItem>
            {item.children && item.children.map((c) => (
              <ListItem key={c.label} sx={{ pl: 4 }} disablePadding>
                <NavLink to={c.path} style={{ width: "100%", textDecoration: "none", color: "inherit" }}>
                  <ListItemButton>
                    <ListItemText primary={c.label} />
                  </ListItemButton>
                </NavLink>
              </ListItem>
            ))}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <button onClick={toggleDrawer(anchor, true)} type="button" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", border: "none", background: "transparent", padding: 8, cursor: "pointer" }}>
            <span className="navbar-toggler-icon"></span>
          </button>

          <SwipeableDrawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)} onOpen={toggleDrawer(anchor, true)}>
            {buildList(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
};
